import gql from "graphql-tag";
import { VARIANT_FRAGMENT_FOR_CART } from "@src/pages/Cart/queries";
import { ORDER_FOR_GA_PURCHASE } from "@src/queries/fragment_order_for_ga_purchase";

export const CHECKOUT_COMPLETE = gql`
  ${ORDER_FOR_GA_PURCHASE}
  mutation checkoutComplete($checkoutId: ID!, $note: String) {
    checkoutComplete(checkoutId: $checkoutId, note: $note) {
      errors {
        field
        message
      }
      cart {
        token
        quantity
        forMgs
        messages {
          level
          message
        }
      }
      order {
        ...orderForGaPurchase
        token
      }
    }
  }
`;

export const ADDRESS_FOR_CHECKOUT_FRAGMENT = gql`
  fragment addressForCheckout on Address {
    id
    firstName
    lastName
    postalCode
    country {
      code
      country
    }
    countryArea
    city
    streetAddress1
    streetAddress2
    phone
    addressNickname
  }
`;

export const CHECKOUT_FRAGMENT = gql`
  ${ADDRESS_FOR_CHECKOUT_FRAGMENT}
  ${VARIANT_FRAGMENT_FOR_CART}
  fragment checkout on Cart {
    id
    token
    paymentType
    quantity
    codRestricted
    messages {
      level
      message
    }
    user {
      point {
        availableAmount
      }
      addresses {
        id
        firstName
        lastName
        streetAddress1
        streetAddress2
        postalCode
        phone
        addressNickname
      }
    }
    originalTotal {
      # for Subtotal field
      # for Discount field (originalTotal - TotalPrice)
      gross {
        amount
      }
    }
    codAmount {
      # for total cod charge field
      amount
    }
    shippingPrice {
      # for delivery charge field
      amount
    }
    usedPoint {
      # for used point field
      amount
    }
    discountAmount {
      # for voucher field
      amount
    }
    totalPrice {
      # maybe for Total field. Check again. Confirmed.
      # https://github.com/velymonkeys/velymonkeys/blob/a230eab110116c102e6d9dc04fb3784f0b48755a/saleor/graphql/checkout/types.py#L150
      gross {
        amount
      }
    }
    voucherCode
    shippingAddress {
      ...addressForCheckout
    }
    subcarts {
      seller {
        name
      }
      totalPrice {
        gross {
          amount
        }
      }
      lines {
        id
        isFreebie
        quantity
        totalPrice {
          gross {
            amount
          }
        }
        variant {
          ...variantForCart
        }
      }
    }
    estimatedEarnPoint {
      amount
    }
    isSelectedMgs
    paymentTypeAvailabilityList {
      key
      title
      subTitle
      available
      canBeShown
    }
  }
`;

export const CHECKOUT_REMOVE_VOUCHER = gql`
  ${CHECKOUT_FRAGMENT}
  mutation checkoutRemoveVoucher($id: ID!) {
    checkoutRemoveVoucher(id: $id) {
      errors {
        field
        message
      }
      checkout {
        ...checkout
      }
    }
  }
`;

export const CHECKOUT_REMOVE_POINT = gql`
  ${CHECKOUT_FRAGMENT}
  mutation checkoutRemovePoint($id: ID!) {
    checkoutRemovePoint(id: $id) {
      checkout {
        ...checkout
      }
      errors {
        field
        message
      }
    }
  }
`;

export const CHECKOUT_UPDATE = gql`
  ${CHECKOUT_FRAGMENT}
  mutation checkoutUpdate($checkoutId: ID, $input: CheckoutUpdateInput!) {
    checkoutUpdate(checkoutId: $checkoutId, input: $input) {
      errors {
        field
        message
      }
      checkout {
        ...checkout
      }
    }
  }
`;
``
export const CHECKOUT = gql`
  ${CHECKOUT_FRAGMENT}
  query checkoutQuery($forMgs: Boolean) {
    checkout(forMgs: $forMgs) {
      ...checkout
    }
  }
`;

export const USER_MOBILE = gql`
  query userMobile {
    me {
      mobileNumber
      mobileVerified
    }
  }
`;